export const JOB_SLIDE_UP_MODAL_ID = 'job-slide-up-modal';
